module.exports = __webpack_public_path__ + "static/media/bannerImg.e62fd564.png";